import { call, put, select, takeLatest } from 'redux-saga/effects';

import supplierSettingsService from 'services/supplierSettingsService';

import { getGroupId } from 'store/session/selectors';

import {
  fetchCheckoutSettings,
  updateCheckoutSettings,
  types,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.CHECKOUT_SETTINGS_UPDATE_REQUEST,
    watchUpdateCheckoutSettings,
  );
}

export function* initSaga() {
  yield call(watchFetchCheckoutSettings);
}

function* watchFetchCheckoutSettings() {
  try {
    const groupId = yield select(getGroupId);
    const { allowLocalPickup, sendOrderConfirmationEmails } = yield call(
      supplierSettingsService.getDigiQuoteSettings,
      groupId,
    );
    yield put(
      fetchCheckoutSettings.success({
        allowLocalPickup,
        sendOrderConfirmationEmails,
      }),
    );
  } catch (e) {
    yield put(fetchCheckoutSettings.error(e));
  }
}

function* watchUpdateCheckoutSettings(action) {
  try {
    const { payload } = action;
    const groupId = yield select(getGroupId);
    const { allowLocalPickup, sendOrderConfirmationEmails } = yield call(
      supplierSettingsService.updateDigiQuoteSettings,
      groupId,
      payload,
    );
    yield put(
      updateCheckoutSettings.success({
        allowLocalPickup,
        sendOrderConfirmationEmails,
      }),
    );
  } catch (e) {
    yield put(updateCheckoutSettings.error(e));
  }
}
